import { deregisterWiToSiStateResolver } from "app/pages/sales-intelligence/utils/wiToSiStateResolver";

/**
 * Leaving SI removes the WI → SI state-name resolver registered in `onEnterSalesIntelligenceRoot` (ADR-0019),
 * so other solutions build their links unchanged.
 */
export const onExitSalesIntelligenceRoot = (): void => {
    deregisterWiToSiStateResolver();
};
